import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVehicleModel = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m21 8.777-2 1.16v5.829l1.585-.924a1 1 0 0 0 .291-.326c.047-.08.081-.156.102-.22S21 14.2 21 14.2zm-10 5.799v5.85l2-1.165v-5.845zm4-2.32v5.84l2-1.165v-5.834zm-.95-9.18a.7.7 0 0 0-.356.094L3.763 8.953l6.254 3.88 10.327-5.988-5.946-3.68a.7.7 0 0 0-.348-.09M3 16.3s.001.035.023.106.057.153.105.24c.094.172.197.288.255.339L9 20.462v-5.906l-6-3.721zm20-2.1c0 .486-.182.963-.401 1.334-.224.378-.557.767-.985 1.024l-.01.006-10.3 6-.01.006a2.72 2.72 0 0 1-2.72-.02l-6.3-3.9-.074-.05c-.347-.26-.632-.637-.828-.996C1.18 17.25 1 16.78 1 16.3V9.7q.002-.361.107-.71a1 1 0 0 1 .22-.523c.256-.463.647-.85 1.123-1.063l10.247-5.968.01-.005a2.72 2.72 0 0 1 2.72.019l6.3 3.9.073.05c.331.248.674.638.907 1.11a1 1 0 0 1 .186.468c.068.23.107.472.107.722z"
	})
});
export default SvgVehicleModel;
